import ClearIcon from '@material-ui/icons/HighlightOff';
import {Box, Button, Grid, IconButton, Typography} from '@material-ui/core';
import {TextValidator} from 'react-material-ui-form-validator';
import {useStyles} from './styles';

/**
 * Repeatable rows for a prescription section. `fields` describes one row: a
 * single entry renders plain strings (lifestyle plan), two entries render
 * objects keyed by `key` (complaints, root cause, yoga).
 */
const SectionRows = ({title, addLabel, fields, rows, updateRows}) => {
  const classes = useStyles();
  const isStringRow = fields.length === 1;
  const list = Array.isArray(rows) ? rows : [];

  const emptyRow = () =>
    isStringRow
      ? ''
      : fields.reduce((row, field) => ({...row, [field.key]: ''}), {});

  const handleChange = (index, key, value) => {
    const updated = [...list];
    updated[index] = isStringRow ? value : {...updated[index], [key]: value};
    updateRows(updated);
  };

  return (
    <Box style={{marginTop: 16}}>
      <Box display="flex" alignContent="center" justifyContent="space-between">
        <Typography variant="h6">{title}</Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() => updateRows([...list, emptyRow()])}
          className={classes.addMedicineButton}
        >
          {addLabel}
        </Button>
      </Box>

      {list.map((row, index) => (
        <Box key={`${title}-${index}`} display="flex" alignItems="center" style={{marginTop: 16}}>
          <Grid container spacing={2} className={classes.medicineDetailsContainer}>
            {fields.map((field) => (
              <Grid item xs={12} sm={field.sm || 12} key={field.key}>
                <TextValidator
                  label={field.label}
                  variant='outlined'
                  fullWidth
                  size='small'
                  multiline={!!field.multiline}
                  rows={field.multiline ? 2 : undefined}
                  value={(isStringRow ? row : row?.[field.key]) || ''}
                  onChange={(e) => handleChange(index, field.key, e.target.value)}
                  placeholder={field.placeholder}
                  validators={field.requiredWith && row?.[field.requiredWith] ? ['required'] : []}
                  errorMessages={[`${field.label} is required`]}
                />
              </Grid>
            ))}
          </Grid>

          {list.length > 1 && (
            <IconButton
              variant="outlined"
              color="secondary"
              onClick={() => updateRows(list.filter((_, i) => i !== index))}
              style={{marginLeft: 8}}
            >
              <ClearIcon/>
            </IconButton>
          )}
        </Box>
      ))}
    </Box>
  )
};

export default SectionRows;
